import dashboardRequest from '@/pages/dashboard/utils/dashboardRequest';

// Revenue图表数据
export const getMonetizationRevenue: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/monetization/revenue/metrics',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// 获取LTV折线图数据
export const getLTVChart: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/monetization/ltv/linechart',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// 获取国家排行榜数据
export const getRevenueBreakdown: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/monetization/revenue/countries_region_zone',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};
// monetization - revenue - 宽表
export const getOverallPerformance: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/monetization/revenue/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false,
  };
  return dashboardRequest(options);
};

// monetization - payment - 宽表平均总值
export const getOverallPerformanceAggregate: (data: any) => Promise<any> = (
  data,
) => {
  const options = {
    url: '/api/v1/dashboard/monetization/revenue/overall_performance/aggregate',
    method: 'post',
    data,
    ignoreRequestId: false,
  };
  return dashboardRequest(options);
};
// monetization - payment - 宽表下载
export const getOverallPerformanceDownLoad: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/monetization/revenue/performance/download?language=${language}`,
    method: 'post',
    data,
    responseType: 'arraybuffer',
    rawData: true,
  };
  return dashboardRequest(options);
};
// monetization - ltv - 热力图宽表
export const getLTVHeatTable: (data: any, language: any) => Promise<any> = (
  data,
  language,
) => {
  const options = {
    url: `/api/v1/dashboard/monetization/ltv/table?language=${language}`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};
// monetization - ltv - 热力图宽表下载
export const downLoadLTVTable: (data: any, language: any) => Promise<any> = (
  data,
  language,
) => {
  const options = {
    url: `/api/v1/dashboard/monetization/ltv/table/download?language=${language}`,
    method: 'post',
    data,
    responseType: 'arraybuffer',
    rawData: true,
  };
  return dashboardRequest(options);
};

// pc console游戏接口

// Revenue图表数据
export const getMtxRevenue: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/monetization/revenue/ingame/trends',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Net Units Per Product 数据
export const getRevenueProduct: (data: any) => Promise<any> = (data) => {
  const options = {
    url: '/api/v1/dashboard/pc/monetization/sales/overview/category_product/breakdown',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getMtxRevenueDistribution: (data: any) => Promise<any> = (
  data,
) => {
  const options = {
    url: '/api/v1/dashboard/pc/monetization/revenue/ingame/platform_distribution/trends',
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getIngameConversionCount: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/revenue/ingame/conversion_count`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getInameRevenueTable: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/revenue/ingame/overall_performance?language=${language}`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getBreakdownRevenueTable: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false,
  };
  return dashboardRequest(options);
};

export const getSalesBreakdownTable: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/breakdown/overall_performance?language=${language}`,
    method: 'post',
    data,
    ignoreRequestId: false,
  };
  return dashboardRequest(options);
};

// time_to_purchase
export const getIngameTimeToPurchas: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/revenue/ingame/time_to_purchase`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Units+DLC Net Revenue Trends
export const getUnitsDlsNetTrends: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/revenue/platform/trends`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const downloadIngameRevenueTable: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/revenue/ingame/overall_performance/download?language=${language}`,
    method: 'post',
    data,
    responseType: 'arraybuffer',
    rawData: true,
  };
  return dashboardRequest(options);
};

export const downloadBreakdownRevenueTable: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/overall_performance/download?language=${language}`,
    method: 'post',
    data,
    responseType: 'arraybuffer',
    rawData: true,
    ignoreRequestId: false,
  };
  return dashboardRequest(options);
};

export const downloadSalesBreakdownTable: (
  data: any,
  language: any,
) => Promise<any> = (data, language) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/breakdown/overall_performance/download?language=${language}`,
    method: 'post',
    data,
    responseType: 'arraybuffer',
    rawData: true,
    ignoreRequestId: false,
  };
  return dashboardRequest(options);
};

// In-Game Breakdown
export const getInGameRevenueBreakdown: (data: any) => Promise<any> = (
  data,
) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/revenue/ingame/breakdown`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Platform Sales Revenue Breakdown
export const getPlatFormBreakdown: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/revenue/platform/breakdown`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getPcConsoleRevenueTree: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/breakdown/dimension/tree`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

// Sales Overview
export const getSalesOverviewPlatForm: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/breakdown`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getSalesOverview: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/trends`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getSalesOverviewDiscount: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/discount_trends`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getSalesOverviewKeyMetrics: (data: any) => Promise<any> = (
  data,
) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/key_performance_metrics`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getSalesOverviewKeyMetricsTrend: (data: any) => Promise<any> = (
  data,
) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/metrics_trend`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getSalesOverviewCard: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/card_metrics`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};

export const getSalesOverviewDimTrend: (data: any) => Promise<any> = (data) => {
  const options = {
    url: `/api/v1/dashboard/pc/monetization/sales/overview/dimension/trends`,
    method: 'post',
    data,
  };
  return dashboardRequest(options);
};
